module.exports = __webpack_public_path__ + "media/images/dscs-9a3ff19e3b883824c10dd1a55b2010af.png";